// src/services/NewArrivalProductServices.js
import api from "../api/api";

/**
 * Normalize backend response to array
 * supports: response.data.data, response.data
 */
const normalizeProductsResponse = (response) => {
  if (!response?.data) return [];
  if (Array.isArray(response.data)) return response.data;
  if (Array.isArray(response.data.data)) return response.data.data;
  return [];
};

export const NewArrivalProductServices = {
  // New arrivals = latest products (your API returns desc by id already)
  getNewArrivals: async (limit = 12) => {
    const res = await api.get("/get-products");
    const products = normalizeProductsResponse(res);
    return limit ? products.slice(0, limit) : products;
  },
};
